import { render, staticRenderFns } from "./GoogleSingIn.vue?vue&type=template&id=7c8fe56d"
import script from "./GoogleSingIn.vue?vue&type=script&lang=js"
export * from "./GoogleSingIn.vue?vue&type=script&lang=js"
import style0 from "./GoogleSingIn.vue?vue&type=style&index=0&id=7c8fe56d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports